import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { Content } from '../../infrastructure/content';
import AcceptError from './components/AcceptError';
import AccountDetailsAccordion from './AccountDetailsAccordion';
import BusinessManadateAccordion from './BusinessMandateAccordion';
import { isAnyAccordianCollapsed } from './reviewUtils';
import SaveAndContinue from '../../components/SaveAndContinue';
class ReviewSectionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nonEdit: 0,
      isFormEdited: false,
      mandateEdit: true,
      accountDetailsEdit: true,
      editClickError: false,
      isPristine: true
    };
    this.isEvidenceCallRequire = false;
    this.editClick = this.editClick.bind(this);
    this.updateReviewCase = this.updateReviewCase.bind(this);
    this.onMandateEditClick = this.onMandateEditClick.bind(this);
    this.resetStateOfnonEdit = this.resetStateOfnonEdit.bind(this);
    this.onAccountDetailsEditClick = this.onAccountDetailsEditClick.bind(this);
    this.onValueChanges = this.onValueChanges.bind(this);
  }
  editClick(isEdit) {
    this.setState({
      nonEdit: isEdit ? this.state.nonEdit + 1 : this.state.nonEdit - 1
    });
    this.onSubmit = this.onSubmit.bind(this);
    if (this.state.nonEdit === 0) {
      this.setState({ editClickError: false });
    }
  }
  onSubmit() {
    this.setState({ ...this.state, isPristine: false });
  }
  componentDidUpdate() {
    if (this.isEvidenceCallRequire) {
      this.isEvidenceCallRequire = false;
      this.processUpdateAccordian();
    }
  }
  resetStateOfnonEdit() {
    if (this.state.accountDetailsEdit && this.state.mandateEdit) {
      this.setState({ nonEdit: 0 });
      this.setState({ editClickError: false });
    }
  }
  processUpdateAccordian() {
    if (!this.state.isFormEdited) {
      if (this.props.linkCode) {
        this.props.redirectToSignificantPeoplePage();
      } else {
        this.props.routeToImportantInfoPage();
      }
    } else if (this.state.nonEdit === 0) {
      this.props.updateReviewCase();
    }
  }
  updateReviewCase() {
    if (this.state.nonEdit > 0) {
      this.setState({ editClickError: true });
    } else if (!this.state.isFormEdited || this.state.nonEdit === 0) {
      if (isAnyAccordianCollapsed(this.state)) {
        if (this.state.accountDetailsEdit) {
          this.onAccountDetailsEditClick();
        }
        if (this.state.mandateEdit) {
          this.onMandateEditClick();
        }
      } else {
        this.processUpdateAccordian();
      }
      this.isEvidenceCallRequire = true;
      this.setState({ editClickError: false });
    } else {
      this.setState({ editClickError: true });
    }
  }
  onValueChanges(value) {
    this.setState({ isFormEdited: value });
  }
  onMandateEditClick() {
    this.setState({ mandateEdit: !this.state.mandateEdit });
    this.resetStateOfnonEdit();
  }
  onAccountDetailsEditClick() {
    this.setState({ accountDetailsEdit: !this.state.accountDetailsEdit });
    this.resetStateOfnonEdit();
  }
  render() {
    const {
      bankId,
      getPaymentTypeCheckboxValue,
      getBusinessData,
      saveDetailsForm,
      saveBusinessMandateForm,
      onAccountDetailsChange,
      businessMandatedata,
      onCountryRemove,
      linkCode
    } = this.props;
    return (
      <div>
        <Content>
          {({
            accountDetailsHeader = '',
            accountDetailsAccordionTitle,
            businessMandatePageTitle
          }) => (
            <div>
              <PageHeading>{accountDetailsHeader}</PageHeading>
              <SectionHeading>{accountDetailsAccordionTitle}</SectionHeading>
              <AccountDetailsAccordion
                getBusinessData={getBusinessData}
                editClick={value => {
                  this.editClick(value);
                }}
                isPristine={this.state.isPristine}
                getPaymentTypeCheckboxValue={getPaymentTypeCheckboxValue}
                bankId={bankId}
                onAccountDetailsChange={onAccountDetailsChange}
                saveDetailsForm={saveDetailsForm}
                onCountryRemove={onCountryRemove}
                onValueChanges={this.onValueChanges}
                linkCode={linkCode}
              />
              <SectionHeading>{businessMandatePageTitle}</SectionHeading>
              <BusinessManadateAccordion
                editClick={value => {
                  this.editClick(value);
                }}
                businessMandatedata={businessMandatedata}
                saveBusinessMandateForm={saveBusinessMandateForm}
                onValueChanges={this.onValueChanges}
                linkCode={linkCode}
              />
            </div>
          )}
        </Content>
        <AcceptError
          nonEdit={this.state.nonEdit === 0}
          editClickError={this.state.editClickError}
        />
        <div className="u-margin-top-3">
          <SaveAndContinue onClick={this.updateReviewCase} />
        </div>
      </div>
    );
  }
}

export default ReviewSectionsPage;
